import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const sendNotifications = createAsyncThunk(
  "massNotifications/sendNotifications",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const channels = [];
      const state = getState() as RootState;
      const documentsTypes = state.massNotification.selectedDocumentTypes;
      const email = state.massNotification.email;
      if (email) channels.push(1);
      const whatsapp = state.massNotification.whatsapp;
      if (whatsapp) channels.push(2);
      const idsDocumentsTypes = documentsTypes.map((documentType) => documentType.id);
      const { data } = await axiosInstance.post(`${api.baseURL}document/send-pending-document-message`, {
        idDocumentType: idsDocumentsTypes,
        organization: state.userAuthentication.user?.sourceOrganization,
        canal: channels,
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
